// src/api/Expenses/expenseDocumentDetailApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📄 Documento
export const getExpenseDocument = async (id) => {
  const res = await axios.get(`${API_URL}/api/expense-documents/${id}`, {
    headers: authHeaders(),
  });
  return res.data;
};

// 📊 Resumen  ✅ CORREGIDO
export const getExpenseSummary = async (id) => {
  const res = await axios.get(
    `${API_URL}/api/expense-documents/${id}/summary`,
    {
      headers: authHeaders(),
    }
  );
  return res.data;
};
